// Validatore di lunghezza per l'input testuale di Customily
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {

    // Mappa dei vincoli
    const LIMITE_CARATTERI = {
        "Arial (Regular)": 18,
        "Impact (Regular)": 14,
        "Georgia (Regular)": 16,
        "Courier New (Regular)": 15,
        "Trebuchet MS (Regular)": 17,
        "Times New Roman (Regular)": 20,
        "Tahoma (Regular)": 16,
        "Verdana (Bold)": 14
    };

    function getSelectedFont() {
        const checked = document.querySelector('input[name="properties[Font]"]:checked');
        return checked ? checked.value.trim() : null;
    }

    // Blocca aggiungi al carrello
    function toggleCartButton(disable) {
        const btns = document.querySelectorAll('#customily-cart-btn, .add-to-cart-button');
        btns.forEach((btn) => {
            btn.disabled = disable;
            btn.style.opacity = disable ? '0.6' : '1';
            btn.style.pointerEvents = disable ? 'none' : 'auto';
        });
    }

    function syncCustomily(element) {
        const event = new Event('input', { bubbles: true });
        element.dispatchEvent(event);
        
        // Alcune versioni di Customily ascoltano il 'change' o il 'blur'
        const changeEvent = new Event('change', { bubbles: true });
        element.dispatchEvent(changeEvent);
    }

    const observer = new MutationObserver(() => {
        const textInput = document.querySelector('input[name="properties[Testo personalizzato]"]');
        if (textInput && !document.querySelector('#char-counter')) {
            const parent = textInput.closest('.cl-option-content');
            if (!parent) return;

            // Counter di caratteri
            const counter = document.createElement('div');
            counter.id = 'char-counter';
            counter.style.marginTop = '6px';
            counter.style.fontSize = '14px';
            counter.style.fontFamily = 'inherit';
            counter.style.color = '#444';
            counter.style.textAlign = 'right';

            // Inserisci prima del bottom spacer
            const spacer = parent.querySelector('.bottom-spacer');
            if (spacer) parent.insertBefore(counter, spacer);
            else parent.appendChild(counter);

            // Gestisci input dinamico
            textInput.addEventListener('input', () => {
                const font = getSelectedFont() || "Arial (Regular)";
                const max = LIMITE_CARATTERI[font] || 18;
                const len = textInput.value.length;
                const remaining = max - len;

                if (len > max) {
                    if (!textInput.dataset.alerting) {
                        textInput.dataset.alerting = "true";
                        alert(`Il font ${font} supporta max ${max} caratteri. Testo adattato.`);
                        setTimeout(() => delete textInput.dataset.alerting, 500);
                    }

                    // FONDAMENTALE: Notifica a Customily che il valore è cambiato dopo il taglio
                    syncCustomily(textInput);            
                    textInput.value = textInput.value.substring(0, max);
                    counter.style.color = '#dc2626';
                    counter.textContent = `${max}/${max} caratteri — Limite raggiunto!`;
                    toggleCartButton(false);
                    return;
                }

                counter.textContent = `${len}/${max} caratteri`;

                if (remaining <= 3 && remaining > 0) {
                    // warning
                    counter.style.color = '#d97706';
                } else if (remaining == 0) {
                    counter.style.color = '#dc2626';
                    counter.textContent += " — Limite raggiunto!";
                }else if (remaining < 0) {
                    counter.style.color = '#dc2626';
                    counter.textContent += " — Limite superato!";
                } else {
                    counter.style.color = '#444';
                }

                toggleCartButton(remaining < 0);
            });

            // Ricalcola se il font cambia
            const fontInputs = document.querySelectorAll('input[name="properties[Font]"]');
            fontInputs.forEach(f => f.addEventListener('change', () => {
                textInput.dispatchEvent(new Event('input'));
            }));

            // Trigger iniziale
            textInput.dispatchEvent(new Event('input'));

            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});